export default __webpack_public_path__ + "static/media/sensla-short-greyscale.05fd672b.png";